<script>
import { machineService } from '../../../helpers/backend/machine.service'
/**
 * Transactions component
 */
export default {
  data() {
    return {
      machineData: [],
      loading: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50],
      filter: null,
      filterOn: [],
      sortBy: "orderid",
      sortDesc: false,
      fields: [
        { key: "id", sortable: true, label: "Machine id" },
        { key: "serial_number", sortable: true, label: "Serial Number" },
        { key: "live_status", sortable: true, label: "Live Status" },
        { key: "last_online", sortable: true, label: "Last Online" },
        { key: "name", sortable: true, label: "Name" },
        { key: "location", sortable: true, label: "Location" },
        { key: "machine_type.name", sortable: true, label: "Machine Type" },
        { key: "outlet.name", sortable: true, label: "Outlet Name" },
        { key: "principle.name", sortable: true, label: "Principle" },
        { key: "action" }
      ],
      showDismissibleAlert: false,
      active: true,
    }
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.machineData.length
    }
  },
  created() {
    this.fetchData()
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.machineData.length
  },
  methods: {
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    invokeCreate() {
      this.setActive(false)
      this.$emit('onActiveCreate')
    },
    setActive(b) {
      this.active = b
    },
    fetchData() {
      this.error = null
      this.loading = true
      this.showDismissibleAlert = false
      //const fetchedId = this.$route.params.id
      machineService.getAllMachine().then(
        data => {
          this.machineData = data.machines
          this.loading = false
        },
        err => {
          this.error = "Failed to fetch machine data. Error : " + err + "  Dissmiss to refresh"
          this.loading = false
          this.showDismissibleAlert = true
        }
      )
    },
    deleteMachine(machineId) {
      if (confirm("Do you really want to delete this instance, this action can't be undone?")) {
        machineService.deleteMachineByID(machineId).then(
          data => {
            this.fetchData()
            console.log(data)
          },
          err => {
            this.error = "Failed to delete machine. Error : " + err
            this.showDismissibleAlert = true
          }
        )
      }
    },
    updateMachine(machineId) {
      this.$emit('onEdit', machineId)
    },
    viewPlanogram(machineId) {
      this.$emit('onView', machineId)
    }
  }
};
</script>

<template>
  <div v-if="active">
    <b-form-group>
      <b-button variant="primary" @click="invokeCreate">Create new</b-button>
    </b-form-group>
    <b-alert
      variant="danger"
      dismissible
      fade
      :show="showDismissibleAlert"
      @dismissed="fetchData"
    >
      {{ error }}
    </b-alert>
    <div class="card">
      <div class="card-body">
        <!-- <b-dropdown right toggle-class="arrow-none card-drop" class="float-right" variant="white">
        <template v-slot:button-content>
          <i class="mdi mdi-dots-vertical"></i>
        </template>
        <b-dropdown-item>Sales Report</b-dropdown-item>
        <b-dropdown-item>Export Report</b-dropdown-item>
        <b-dropdown-item>Profit</b-dropdown-item>
        <b-dropdown-item>Action</b-dropdown-item>
      </b-dropdown> -->

        <!-- <h4 class="card-title mb-4">(.*)</h4> -->
        <div class="row mt-4">
          <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center">
                Show&nbsp;
                <b-form-select
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                ></b-form-select
                >&nbsp;entries
              </label>
            </div>
          </div>
          <!-- Search -->
          <div class="col-sm-12 col-md-6">
            <div
              id="tickets-table_filter"
              class="dataTables_filter text-md-right"
            >
              <label class="d-inline-flex align-items-center">
                Search:
                <b-form-input
                  v-model="filter"
                  type="search"
                  class="form-control form-control-sm ml-2"
                ></b-form-input>
              </label>
            </div>
          </div>
          <!-- End search -->
        </div>
        <div class="table-responsive">
          <b-table
            :items="machineData"
            :fields="fields"
            responsive="sm"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template v-slot:cell(live_status)="row">
              <div
                class="badge font-size-12"
                :class="{
                  'badge-success': row.item.live_status == true,
                  'badge-danger': row.item.live_status == false,
                }"
              >
                {{ row.item.live_status == true ? "Online" : "Offline" }}
              </div>
            </template>

          <template v-slot:cell(last_online)="row">
              {{ row.item.last_online==null? "" : new Date(row.item.last_online).toDateString() + " " + new Date(row.item.last_online).toLocaleTimeString() }}
            </template>

          <template v-slot:cell(action)="row">
            <a
              @click="updateMachine(row.item.id)"
              class="mr-3 text-primary"
              v-b-tooltip.hover
              data-toggle="tooltip"
              title="Edit"
            >
              <i class="mdi mdi-pencil font-size-18"></i>
            </a> <a
              @click="viewPlanogram(row.item.id)"
              class="mr-3 text-primary"
              v-b-tooltip.hover
              data-toggle="tooltip"
              title="View Planogram"
            >
              <i class="mdi mdi-eye font-size-18"></i>
            </a>
            <a @click="deleteMachine(row.item.id)" class="text-danger" v-b-tooltip.hover title="Delete">
              <i class="mdi mdi-trash-can font-size-18"></i>
            </a>
          </template>
        </b-table>
      </div>
      <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-right">
            <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>